var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWClose = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 50,
  height: 38,
  viewBox: "0 0 50 38",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M25 18.2857L20.7143 14L20 14.7143L24.2857 19L20 23.2857L20.7143 24L25 19.7143L29.2857 24L30 23.2857L25.7143 19L30 14.7143L29.2857 14L25 18.2857Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgWClose);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "f721def3d1de94b58a4daa9fc0a247ed.svg";